/* loaded by smart-asset */
export default require("./assets/conveyor.i.svg")